import { render, staticRenderFns } from "./OrderDeliveryProfileWidget.vue?vue&type=template&id=6a3cd731&scoped=true"
import script from "./OrderDeliveryProfileWidget.vue?vue&type=script&lang=ts"
export * from "./OrderDeliveryProfileWidget.vue?vue&type=script&lang=ts"
import style0 from "./OrderDeliveryProfileWidget.vue?vue&type=style&index=0&id=6a3cd731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3cd731",
  null
  
)

export default component.exports